var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgValidate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.188,
    height: 16.753,
    viewBox: "0 0 21.188 16.753",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_49",
    "data-name": "Trac\\xE9 49",
    d: "M38.649,979.05l-1.527,1.527c-3.364,3.371-5.957,6.2-9.039,9.353l-3.133-2.65L23.3,985.888l-2.785,3.29,1.651,1.392,4.671,3.952,1.516,1.28,1.4-1.4c3.877-3.885,6.632-6.983,10.42-10.779l1.527-1.527Z",
    transform: "translate(-20.516 -979.05)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValidate);
export default __webpack_public_path__ + "static/media/validate.7ccec98bb7106da259939f182e3b4424.svg";
export { ForwardRef as ReactComponent };